/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateCheckListItemRequestViewModel } from "../types/CreateCheckListItemRequestViewModel.ts";

export const createCheckListItemRequestViewModelSchema = z.object({
  description: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CreateCheckListItemRequestViewModel>;
